'use strict'

function traceReporterCreator(reportTrace) {
  function doTrace(params) {
    try {
      reportTrace(params)
    } catch (e) {}
  }

  const api = {
    traceStart: function traceStart(actionName, params) {
      const ts = Date.now()
      doTrace(Object.assign({ actionName, tracePosition: 'before' }, params))
      return function traceEnd(endParams) {
        const actionDurationMs = Date.now() - ts
        doTrace(
          Object.assign(
            { actionName, tracePosition: 'after', actionDurationMs },
            endParams
          )
        )
      }
    }
  }
  return api
}

module.exports = traceReporterCreator



// WEBPACK FOOTER //
// ./tracing/traceReporter.js